import { FavoriteCapabilityConfiguration } from './configuration';
import { MyFavoritesRoutes } from './routes';
import { MyFavoritesCategoryController } from './views/my_favorites_category/my_favorites_category_controller';

angular
  .module('capability-ng-favorites', [
    'ngSanitize',
    'utility-ng-enumeration',
    'utility-ng-interface',
    'utility-ng-pipeline',
    'ui-ng-delegate',
    'ui-ng-calendar-time',
    'biz-ng-career-details',
    'capability-ng-major-explorer',
    'capability-ng-resources'
  ])
  .controller('MyFavoritesCategoryController', MyFavoritesCategoryController)
  .service('ngFavoriteCapabilityConfiguration', FavoriteCapabilityConfiguration)
  .config(MyFavoritesRoutes);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-favorites/src/capability_ng_favorites_module.ts